import { styled } from 'styled-components'
import { SubtractIcon } from '../../../../../../icons'

export const HighlightedSubtractIcon = styled(SubtractIcon)`
  color: ${({ theme }) => theme.colors.primary};
  fill: ${({ theme }) => theme.colors.primary};
  margin-right: 1px;
`
